import React from "react";
import ShipmentRateForm from "../../forms/SearchRates/ShipmentRate/ShipmentRateForm";

const ShipmentRates = ({ searchBy, searchFormData, type }) => {
  return (
    <ShipmentRateForm searchBy={searchBy} searchFormData={searchFormData} type={type} />
  );
};


export default ShipmentRates;
